import websiteRatingModel from '@/components/common/stat/website-rating-model'

let mixin = {
  components:{
    websiteRatingModel

  }
}

export default mixin;
